import type * as Blockly from 'blockly/core';
import { BOARD_CONFIG } from '@/(routers)/boards/editor/block/blockConfig';
import {
    expr,
    registerHelperFunction,
    registerSetupCode,
    resolveBoard,
} from '@/(routers)/boards/editor/block/generators/arduino/_gen';

type Position = keyof (typeof BOARD_CONFIG)[keyof typeof BOARD_CONFIG]['pins'];

const HELPER_CODE = `unsigned long distanceTimeOut = 100000;
float _sbeGetDistanceUsingDistanceSensor(int trigPin, int echoPin) {
  long distance = 0;
  long duration = 0;

  pinMode(trigPin, OUTPUT);
  pinMode(echoPin, INPUT);

  digitalWrite(trigPin, LOW);
  delayMicroseconds(2);
  digitalWrite(trigPin, HIGH);
  delayMicroseconds(10);
  digitalWrite(trigPin, LOW);

  duration = pulseIn(echoPin, HIGH, distanceTimeOut);
  if (duration > 0) {
    distance = duration / 2 * 340 * 100 / 1000000;
  }
  return distance;
}`;

export function register(gen: any): void {
    gen.forBlock['distance'] = function (block: Blockly.Block): [string, number] {
        const position = block.getFieldValue('POSITION') as Position;
        const board = resolveBoard(block);
        const pins = BOARD_CONFIG[board].pins[position];
        const trig = pins.first;
        const echo = pins.second;

        registerHelperFunction('distance', HELPER_CODE);
        registerSetupCode(String(trig), `  digitalWrite(${trig}, LOW);\n`);

        return expr(`_sbeGetDistanceUsingDistanceSensor(${trig} , ${echo})`);
    };
}
